import { IdTypes } from 'bundles/product-features';
import { LEGAL_MARKETING_CONSENT_MODAL_RESTRICTED_ENTERPRISES as LEGAL_RESTRICTED_ENTERPRISES } from 'bundles/user-consent/constants';
import { useProductFeatures } from 'bundles/user-consent/utils';

type Props = {
  thirdPartyOrgIds: string[];
  shouldSkipQuery?: boolean;
};

// Product feature toggle to opt out orgs from receiving enterprise emails https://www.coursera.org/internal/feature-toggles?name=allowAnyEmailsForEnterprise&namespace=enterpriseEmails
const useMarketingConsentRestrictedEnterprises = ({ thirdPartyOrgIds, shouldSkipQuery = false }: Props) => {
  const isLegalRestrictedEnterprises = thirdPartyOrgIds.some((thirdPartyOrganizationId) => {
    return LEGAL_RESTRICTED_ENTERPRISES.includes(thirdPartyOrganizationId);
  });

  // Due to a limitation in the product features API, we're currently only considering the first org.
  // Once the API supports multi-get, we should update this to handle all orgs.
  const thirdPartyOrgId = thirdPartyOrgIds[0];

  const { features, loading: areProductFeaturesLoading } = useProductFeatures({
    idType: IdTypes.Organization,
    // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    id: thirdPartyOrgId,
    skip: isLegalRestrictedEnterprises || shouldSkipQuery || !thirdPartyOrgId,
    ssr: true,
  });
  const isRestrictedEnterpriseUser =
    isLegalRestrictedEnterprises || !features.get('enterpriseEmails', 'allowAnyEmailsForEnterprise');

  return {
    loading: areProductFeaturesLoading,
    isRestrictedEnterpriseUser,
  };
};

export default useMarketingConsentRestrictedEnterprises;
